import React, { Component } from "react";
import { connect } from "react-redux";
import RaisedButton from "material-ui/RaisedButton";
import { showNotification as showNotificationAction } from "admin-on-rest";
import { push as pushAction } from "react-router-redux";
import axios from "axios";
var Config = require("../config");

class PrintButton extends Component {
  handleClick = () => {
    var auth_token = localStorage.getItem("auth_token");

    axios
      .post(Config.serverUrl + `api/update_all`, {
        token: auth_token
      })
      .then(res => {
        console.log(res);
        console.log(res.data);
        alert("Η ενημέρωση ολοκληρώθηκε. Παρακαλώ περιμένετε τουλάχιστον 10 λεπτά πριν ενημερώσετε την εφαρμογή.");
      });
  };

  render() {
    return (
      <RaisedButton
        label="Ενημερωση δεδομενων"
        onClick={this.handleClick}
        primary={true}
      />
    );
  }
}

export default connect(
  null,
  {
    showNotification: showNotificationAction,
    push: pushAction
  }
)(PrintButton);



// WEBPACK FOOTER //
// ./src/custom/UpdateButton.js